<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { calcInitTime } from '@/utils/sign'
import pkg from './package.json'
import { useInitDefaultStore } from '@/stores/defaultStore'

console.info('%cversion: ' + pkg.version, 'color:red;font-size:20px')
if (import.meta.client) {
  calcInitTime()
  useInitDefaultStore()
}
</script>
